import React, { FC, useRef } from 'react'

import clsx from 'clsx'
import { useHoverDirty } from 'react-use'

import { Icon, Txt } from 'src/components/atoms'

import { useToast } from 'src/hooks'

type Props = {
  title: string
  text: string
  className?: string
}

export const CodeSnippet: FC<Props> = ({ title, text, className }) => {
  const ref = useRef(null)
  const isHovering = useHoverDirty(ref)

  const { displayStandardTextToast, displayErrorTextToast } = useToast()

  const copyToClipboard = async (content: string) => {
    try {
      await navigator.clipboard.writeText(content)
      displayStandardTextToast('コピーしました')
    } catch {
      displayErrorTextToast('コピーに失敗しました')
    }
  }

  return (
    <div className={clsx(className, 'tw-rounded-[4px] tw-overflow-hidden')}>
      <div className="tw-full-justify tw-h-s2 tw-bg-background-secondary">
        <Txt
          sizeType="s"
          className="tw-centering tw-text-standardText-secondary tw-bg-background-primary tw-h-full tw-px-s1"
        >
          {title}
        </Txt>
        <button
          type="button"
          onClick={() => copyToClipboard(text)}
          className="hover:tw-bg-standardText-secondary tw-h-full tw-centering tw-outline-none"
          ref={ref}
        >
          <div
            className={clsx(
              'tw-centering tw-px-s-1',
              isHovering ? 'tw-text-inlineText-primary' : 'tw-text-standardText-secondary'
            )}
          >
            <Icon size="--r0" path="copy/soft/line" className="tw-mr-s-4" />
            <Txt sizeType="xs">コピー</Txt>
          </div>
        </button>
      </div>
      <div className="tw-flex tw-justify-start tw-items-center tw-bg-background-primary tw-h-s5">
        <Txt className="tw-ml-r1">{text}</Txt>
      </div>
    </div>
  )
}
